import { useCallback } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { useValidation } from 'components/modules/Insurance/hooks/useValidation';
import { updatePolicyholder } from 'store/insurance/actions';
import { insAnketaInsurerSetErrors, insAnketaSetErrors } from 'store/insuranceAnketa';
import { FIELDS } from 'store/insuranceAnketa/constants';
import { selectInsuranceAnketa } from 'store/insuranceAnketa/selectors';

import { policyholderSchema } from '../Policyholder.validation';

export const useSubmit = () => {
  const dispatch = useDispatch();

  const values = useSelector(selectInsuranceAnketa);

  const { validate } = useValidation({ schema: policyholderSchema, values });

  const onSetErrors = useCallback(({ action, errors }) => {
    dispatch(action({ errors }));
  }, []);
  const onSubmit = useCallback(async () => {
    const errors = await validate();
    const { [FIELDS.KASKO_INSURER]: insurerErrors, ...rawOwnerErrors } = errors;
    const ownerErrors = Object.keys(rawOwnerErrors) ? rawOwnerErrors : undefined;
    const error = Boolean(insurerErrors || ownerErrors);

    if (ownerErrors) {
      onSetErrors({ action: insAnketaSetErrors, errors: ownerErrors });
    }

    if (insurerErrors) {
      onSetErrors({ action: insAnketaInsurerSetErrors, errors: insurerErrors });
    }

    if (!error) {
      dispatch(updatePolicyholder());
    }
  }, [validate, onSetErrors]);

  return { onSubmit };
};
